import { ResponseDto } from '@diritto/common/base/response.dto';
import { ContentNewEpisodeNotiResponseDto } from '@diritto/common/content/dtos/content-new-episode-noti.dtos';
import { Http } from '@diritto/common/utils/requester/http';

export class ContentNotiApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async addNewEpisodeNoti(contentId: number) {
    const res = await this.http.post<undefined, ResponseDto>(
      `${this.url}/contents/${contentId}/notifications/new-episode`,
    );
    return res.data;
  }

  async deleteNewEpisodeNoti(contentId: number) {
    const res = await this.http.delete<ResponseDto>(`${this.url}/contents/${contentId}/notifications/new-episode`);
    return res.data;
  }

  async deleteNewEpisodeNotiBulk(contentIds: number[]) {
    const res = await this.http.delete<ResponseDto>(`${this.url}/contents/notifications/new-episode/bulk`, {
      data: { contentIds },
    });
    return res.data;
  }

  async getNewEpisodeNoti(contentId: number) {
    const res = await this.http.get<ContentNewEpisodeNotiResponseDto>(
      `${this.url}/contents/${contentId}/notifications/new-episode`,
    );
    return res.data;
  }
}
